import React from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { AthleteProps, LeagueProps, MyPlayerProps, OrderProps, PlayerPremiumItem, PremiumItemProps, PublicPlayerProps, TeamProps } from "../../types"
import { useColors } from '../../constants/useColors';
import { MarketComponentHelpers } from '../../MarketComponents/api';
import { Image } from 'react-native';
import { AthleteImage, TeamImage } from '../../Components/Jerseys';
import OrderGradeBar from '../../MarketComponents/components/OrderGradeBar';
import { PremiumHelpers } from '../../Premium/api';

type BetMatchCardSmallProps = {
    player:PublicPlayerProps,
    contest_title:string,
    player_premium_items?:PlayerPremiumItem[],
    premium_items?:PremiumItemProps[],
    me?:MyPlayerProps,
    time_detail:string,
    league?:LeagueProps,
    team?:TeamProps,
    athlete?:AthleteProps,
    order:OrderProps,
    onOrder:(order:OrderProps) => void
}
const BetMatchCardSmall = ({ me, player_premium_items, premium_items, contest_title, time_detail, team, athlete, league, order, onOrder }:BetMatchCardSmallProps) => {
    const Colors = useColors();
    const premium_order_grades = PremiumHelpers.getItemFromIdentifer('order_grades', premium_items, player_premium_items);
    const show_grades = premium_order_grades.player_premium_item?.status == 'active' || me?.type == 'premium' ? true : false
    return (
        <Button float style={{ flex:1, padding:0 }} onPress={() => onOrder(order)}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:5, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <View float style={{ borderRadius:100, padding:2 }}>
                {athlete ?
                   <AthleteImage
                    athlete={athlete}
                    size={36}
                   />
                :team ?
                <TeamImage
                    team={team}
                    size={14}
                   />
                :league ?
                <Image
                    source={{ uri: league.league_image }}
                    style={{ height:36, width:36, borderRadius:100 }}
                    resizeMode='cover'
                />
                :<></>
                }
                </View>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='description' size={12}>{order.title}</Text>
                    <Text theme='h1' size={12} color={Colors.text.success} style={{ marginTop:3 }}>${order.open_amt.toFixed(2)} Available</Text>
                </View>
            </View>
            <View type='body' style={{ flex:1 }}>
                
                <View transparent type='row' style={{ padding:5, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                    <View style={{ flex:1 }}>
                        <Text theme='h2' size={12}>Offer Odds:</Text>
                        <OrderGradeBar mask={!show_grades} style={{ alignItems:'flex-start', marginTop:5 }} grade={order.grade} view_type='card' />
                    </View>
                    <Text theme='h1'>{MarketComponentHelpers.getOddsLabel(order.odds)}</Text>
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', borderBottomLeftRadius:8, borderBottomRightRadius:8, padding:5 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h2'>{contest_title}</Text>
                    <Text theme='light' style={{ marginTop:3 }}>{time_detail}</Text>
                </View>
            </View>
        </Button>
    )
}

export default BetMatchCardSmall